<template>
  <loading :loading="isLoading">
    <b-card header="Related extract data">
      <error :error="error"/>
      <div v-if="page">
        <b-list-group flush>
            <b-list-group-item>
              <small-business-rate-relief :hide-rv="false" :cases="page.Sbrr"/>
            </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>
  </loading>
</template>

<script>
import Loading from '../Loading.vue'
import Error from '../Error.vue'
import SmallBusinessRateRelief from '../extract_views/SmallBusinessRateRelief.vue'

export default {
  components: { Loading, Error, SmallBusinessRateRelief },
  props: ['reference'],
  data() {
    return {
      isLoading: true,
      page: null,
      error: null,
    };
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'sbrr_one_breaches_2900_threshold',
      parameters: {
        reference: this.reference,
      },
    })
    .then((page) => { this.page = page; this.isLoading = false; })
    .catch((e) => { this.error = e.message; this.isLoading = false; });
  },
};
</script>
